import { message } from "antd";
import axios from "axios";
import download from "downloadjs";

// Generate product image
export const generateInteriorDesign =
    (uploaded_image_object, prompt, room_type, room_theme) =>
    async (dispatch) => {
        await axios
            .post(`/api/interior_designs/generate_interior_design`, {
                uploaded_image: uploaded_image_object,
                prompt: prompt,
                room_type: room_type,
                room_theme: room_theme,
            })
            .then(async (response) => {
                dispatch({
                    type: "GENERATE_INTERIOR_DESIGN_SUCCESS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Download product image
export const downloadInteriorDesign =
    (interior_design_uuid, format, resolution, size) => async (dispatch) => {
        await axios
            .get(
                `/api/interior_designs/download/${interior_design_uuid}/${format}/${resolution}/${size}`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then(async (response) => {
                await download(
                    response.data,
                    `img.${format}`,
                    `image/${format}`
                );
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch seamless products of a user
export const fetchUserInteriorDesigns =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(
                `/api/interior_designs/user_interior_designs/${key}/${offset}/${limit}`
            )
            .then(async (response) => {
                dispatch({
                    type: "FETCH_USER_INTERIOR_DESIGNS_SUCCESS",
                    payload: response.data,
                    key: "user_interior_designs" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
